@use '@maltjoy/icons/dist/joy-icons.css';
@use './config';

$_CLASS: '.joy-icon';

$_ICONS-COLORS: (
    "teal": (
            color: var(--joy-color-secondary-50),
            placeholder: var(--joy-color-secondary-10)
    ),
    "grey": (
            color: var(--joy-color-neutral-40),
            placeholder: var(--joy-color-neutral-20)
    ),
    "red": (
            color: var(--joy-color-primary-50),
            placeholder: var(--joy-color-primary-10)
    ),
    "yellow": (
            color: var(--joy-color-quaternary-70),
            placeholder: var(--joy-color-quaternary-10)
    ),
    "turquoise": (
            color: var(--joy-color-tertiary-50),
            placeholder: var(--joy-color-tertiary-10)
    ),
    "white": (
            color: white,
            placeholder: rgba(255, 255, 255, 0.2)
    ),
    "success": (
            color: var(--joy-color-success-50),
            placeholder: var(--joy-color-success-10)
    ),
    "error": (
            color: var(--joy-color-error-50),
            placeholder: var(--joy-color-error-10)
    ),
    "info": (
        color: var(--joy-color-information-50),
        placeholder: var(--joy-color-information-10)
    )
);

:host {
  /**
   * @prop --icon-size: customize icon size with px value.
   */
  --icon-size: #{config.$icon-xsmall};

  display: inline-flex;
  color: var(--joy-color-secondary-50);
}

#{$_CLASS}--clickable {
  cursor: pointer;
}

@each $name, $size in config.$ICON_SIZES {
  #{$_CLASS}--#{$name} {
    --icon-size: #{$size};
  }
}

@each $colorName, $params in $_ICONS-COLORS {
  :host(#{$_CLASS}--#{$colorName}) {
    color: map-get($params, color);
  }
}

.joy-icon-inner {
  // Default
  // Prevent clicking on svg or use elements when adding a listener
  pointer-events: none;
  min-width: var(--icon-size);
  width: var(--icon-size);
  height: var(--icon-size);

  i.icon {
    display: block;
    font-size: var(--icon-size);
  }
}